import styled from "styled-components";
import {errorRed} from "../../components/colors";

export const StyledError = styled.div`
  .error-message-name {
    color: ${errorRed};
    width: 100%;
  }
`;
